<template>
    <component 
        :is='componente' 
        :componente="componente" 
        :projeto="projeto"
        :ref="componente"
        @update="update"
        :projeto-editavel="projetoEditavel"
        :chave-permissao="chavePermissao"
    />
</template>
<script>
export default {
    components: {
        'detalhes': () => import('./accordions/detalhes'),
        'empresas' : () => import('./accordions/empresas'),
        'rh': () => import('./accordions/recurso_humano'),
        'st': () => import('./accordions/rubricas'),
        'mc' : () => import('./accordions/rubricas'),
        'vd': () => import('./accordions/rubricas'),
        'ou' : () => import('./accordions/rubricas'),
        'ct' : () => import('./accordions/rubricas'),
        'auditoria' : () => import('./accordions/rubricas'),
        'cronograma_etapa' : () => import('./accordions/cronograma_etapa'),
        'atividades' : () => import('./accordions/atividades'),
        'aneel' : () => import('./accordions/aneel'),
        'investimentos' : () => import('./accordions/investimentos'),
        'documentos' : () => import('./accordions/contrato_documentacao'),
        'producao-cientifica': () => import('./accordions/resultados'),
        'capacitacao-profissional': () => import('./accordions/resultados'),
    },
    props: {
        componente: {
            type: String,
            default: null
        },
        projeto: {
            type: Object,
            default: null
        },
        chavePermissao: {
            type: String,
            default: null
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    }, 
    methods : {
        montar(tela){
            /* eslint-disable */
            try{
                this.$refs[tela].montar();
            }catch(e){
            }
        },
        update() {
            this.$emit('update'); 
        },
    }
    
}
</script>
<style lang="">
    
</style>